import { Component } from '@angular/core';

@Component({
    selector: 'app-confirm-change-month-modal',
    templateUrl: './confirm-change-month-modal.component.html',
    styleUrls: ['./confirm-change-month-modal.component.scss'],
})
export class ConfirmChangeMonthModalComponent {}
